// extracted by mini-css-extract-plugin
export default {"primaryColor":"navy","primaryColorWithAlpha":"rgba(0,0,128,.1019607843)","mainBgColor":"#f8f9fd","secondBgColor":"#1e2035"};